import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import UsersSearch, { SEARCH_HINT } from './UsersSearch';

const renderSearch = (props = {}) => {
  const onSearch = jest.fn();

  render(
    <ConfigProvider>
      <UsersSearch onSearch={onSearch} {...props} />
    </ConfigProvider>,
  );

  return {
    onSearch,
    input: screen.getByRole('textbox', { name: /search users/i }),
  };
};

const pressEnter = (input) =>
  fireEvent.keyPress(input, { key: 'Enter', charCode: 13 });

describe('management/Users UsersSearch', () => {
  it('tells the user what the search covers', () => {
    renderSearch();

    expect(screen.getByText(SEARCH_HINT)).toBeInTheDocument();
  });

  it('shows the term already applied', () => {
    const { input } = renderSearch({ value: 'martinez' });

    expect(input).toHaveValue('martinez');
  });

  // The Figma component is "Search on Submit", so this searches on Enter rather
  // than per keystroke — unlike the filter menus.
  it('does not search while the user is typing', () => {
    const { input, onSearch } = renderSearch();

    fireEvent.change(input, { target: { value: 'mar' } });

    expect(onSearch).not.toHaveBeenCalled();
  });

  it('searches on Enter', () => {
    const { input, onSearch } = renderSearch();

    fireEvent.change(input, { target: { value: 'martinez' } });
    pressEnter(input);

    expect(onSearch).toHaveBeenCalledWith('martinez');
  });

  // Emptying the box restores the full list without needing another Enter.
  it('searches immediately when the box is emptied', () => {
    const { input, onSearch } = renderSearch({ value: 'martinez' });

    fireEvent.change(input, { target: { value: '' } });

    expect(onSearch).toHaveBeenCalledWith('');
  });

  it('keeps up when the applied term changes elsewhere', () => {
    const { rerender } = render(
      <ConfigProvider>
        <UsersSearch value="martinez" onSearch={jest.fn()} />
      </ConfigProvider>,
    );

    rerender(
      <ConfigProvider>
        <UsersSearch value="" onSearch={jest.fn()} />
      </ConfigProvider>,
    );

    expect(screen.getByRole('textbox', { name: /search users/i })).toHaveValue(
      '',
    );
  });
});
